/**
 * Styles for FeedDrawer component
 */
export const drawerStyles = {
  display: 'flex',
  width: '768px',
  height: '1024px',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'flex-start',
  gap: '12px',
  borderLeft: '10px solid var(--Navy---navy-main, #061E44)',
  background: 'var(--Greyscale-white, #FFF)',
};

export const drawerContentStyles = {
  width: '100%',
  height: '100%',
  padding: '12px',
  boxSizing: 'border-box',
};

